/* eslint-disable default-case */
import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from './SortFilter.module.css';
import constants from '../../../../globalization';
import PopupHeader from '../PopupHeader';
import { updateViewType } from '../../../../store/actions/notification';
import FireboardUtils from '../../../../util/fireboard-util';

const Toggle = (props) => {
  const { selected, toggleSelected, disabled } = props;
  return (
    <div className={styles.toggleContainer} onClick={disabled ? null : toggleSelected}>
      <div className={[styles.dialogButton, selected ? "" : styles.disabled].join(" ")} />
    </div>
  );
};

Toggle.propTypes = {
  selected: PropTypes.bool,
  toggleSelected: PropTypes.func,
  disabled: PropTypes.bool,
};

Toggle.defaultProps = {
  selected: false,
  toggleSelected: () => { },
  disabled: false,
};

const ToggleSetting = ({ settingName, option1, option2, selected, toggleSelected, disabled }) => {
  return (
    <div className={styles.toggleWrapper}>
      <div className={styles.textLabel}>{settingName}</div>
      <div className={styles.toggleTextWrapper}>
        <span className={styles.sortOptions}>{option1}</span>
        <Toggle selected={selected} toggleSelected={toggleSelected} disabled={disabled} />
        <span className={styles.sortOptions}>{option2}</span>
      </div>
    </div>
  );
};

ToggleSetting.propTypes = {
  settingName: PropTypes.string,
  option1: PropTypes.string,
  option2: PropTypes.string,
  selected: PropTypes.bool,
  toggleSelected: PropTypes.func,
  disabled: PropTypes.bool,
};

ToggleSetting.defaultProps = {
  settingName: '',
  option1: '',
  option2: '',
  selected: false,
  toggleSelected: () => { },
  disabled: false,
};

class SortFilter extends React.Component<> {
  toggleViewType = e => {
    const { toggleView, dispatchUpdateViewType } = this.props;
    const type = e.target.value;
    toggleView(type);
    dispatchUpdateViewType({ viewType: type });
  };

  onToggleSetting = type => {
    const { dispatchUpdateViewType, reduxProps } = this.props;
    const { checkSortReducer } = reduxProps;
    const { data: { viewErrorOrders, fbDisableAutoPrinting, pagination, groupedView } } = checkSortReducer || {};
    if (type === 'viewErrorOrder') {
      dispatchUpdateViewType && dispatchUpdateViewType({ viewErrorOrders: !viewErrorOrders });
    } else if (type === 'autoPrinting') {
      dispatchUpdateViewType && dispatchUpdateViewType({ fbDisableAutoPrinting: !fbDisableAutoPrinting });
    } else if (type === 'pagination') {
      dispatchUpdateViewType && dispatchUpdateViewType({ pagination: !pagination });
    } else if (type === 'grouping') {
      dispatchUpdateViewType && dispatchUpdateViewType({ groupedView: !groupedView });
    }
  };

  render() {
    const { onClose, sortFilter, setSortType, reduxProps, deviceGroup } = this.props;
    const { checkSortReducer } = reduxProps;
    const { data: { viewType = 'list', viewErrorOrders, fbDisableAutoPrinting = false, pagination = false, groupedView = false } } = checkSortReducer;
    const { fireBoardSettings } = deviceGroup || {};
    const deviceGroupIsNotNull = !FireboardUtils.isObjectBlank(deviceGroup);
    const isTileView = deviceGroupIsNotNull
      ? fireBoardSettings?.tileView
      : viewType === 'card';

    return (
      <div className={styles.container}>
        <PopupHeader title={"SETTINGS"} onClose={onClose} containerStyle={styles.heading} />
        <div className={styles.bodyContainer}>
          <ToggleSetting
            settingName={'Check Sort Order'}
            option1={'Oldest first'}
            option2={'Latest first'}
            selected={sortFilter}
            toggleSelected={setSortType}
            disabled={deviceGroupIsNotNull}
          />
          <div className={styles.toggleWrapper}>
            <div className={styles.textLabel}>View Type</div>
            <div className={styles.toggleTextWrapper}>
              <div className={styles.radioView}>
                <input
                  type="radio"
                  name="list"
                  value={'list'}
                  checked={!isTileView}
                  onChange={this.toggleViewType}
                  className={styles.radio}
                  disabled={deviceGroupIsNotNull} />
                <span className={[styles.sortOptions, styles.margn].join(' ')}>List View</span>
              </div>
              <div className={styles.radioView}>
                <input
                  type="radio"
                  name="card"
                  value={'card'}
                  checked={isTileView}
                  onChange={this.toggleViewType}
                  className={styles.radio}
                  disabled={deviceGroupIsNotNull} />
                <span className={[styles.sortOptions, styles.margn].join(' ')}>Tiles View</span>
              </div>
            </div>
          </div>
          <ToggleSetting
            settingName={constants.viewErrorOrders}
            option1={constants.disabled}
            option2={constants.enabled}
            //If device group is not null then check displayErrorOrderWarning key in deviceGroup.fireBoardSettings object & toggle selection based on its value
            selected={deviceGroupIsNotNull ? fireBoardSettings?.displayErrorOrderWarning : viewErrorOrders}
            toggleSelected={() => this.onToggleSetting('viewErrorOrder')}
            disabled={deviceGroupIsNotNull}
          />
          <ToggleSetting
            settingName={constants.disableAutoPrinting}
            option1={constants.no}
            option2={constants.yes}
            //If device group is not null then make the selection based on value of "deviceGroup.fireBoardSettings.enableAutoPrinting"
            selected={deviceGroupIsNotNull ? !fireBoardSettings?.enableAutoPrinting : fbDisableAutoPrinting}
            toggleSelected={() => this.onToggleSetting('autoPrinting')}
            disabled={deviceGroupIsNotNull}
          />
          <ToggleSetting
            settingName={constants.pagination}
            option1={constants.no}
            option2={constants.yes}
            selected={deviceGroupIsNotNull ? fireBoardSettings?.paginatedView : pagination}
            toggleSelected={() => this.onToggleSetting('pagination')}
            disabled={deviceGroupIsNotNull}
          />
          <ToggleSetting
            settingName={constants.grouping}
            option1={constants.no}
            option2={constants.yes}
            selected={deviceGroupIsNotNull ? fireBoardSettings?.groupedView : groupedView}
            toggleSelected={() => this.onToggleSetting('grouping')}
            disabled={deviceGroupIsNotNull}
          />
        </div>
      </div >
    );
  }
};

const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = dispatch => ({
  dispatchUpdateViewType: (payload) => {
    dispatch(updateViewType(payload));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SortFilter);